const HBB_QUOTE_SUMMARY_SEPARATOR = '\n\n--- Din beskrivning ---\n';

class HbbProductQuoteModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.quantity = this.querySelector('[data-hbb-quote-quantity]');
    this.marking = this.querySelector('[data-hbb-quote-marking]');
    this.formHost = this.querySelector('[data-hbb-quote-form-host]');

    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleDialogClick = this.handleDialogClick.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
    this.handleFormInteraction = this.handleFormInteraction.bind(this);

    document.addEventListener('click', this.handleDocumentClick);
    this.dialog?.addEventListener('click', this.handleDialogClick);
    this.dialog?.addEventListener('close', this.handleDialogClose);
    this.addEventListener('click', this.handleFormInteraction, true);
    this.addEventListener('submit', this.handleFormInteraction, true);
    this.quantity?.addEventListener('input', () => this.syncQuoteSummary());
    this.marking?.addEventListener('change', () => this.syncQuoteSummary());

    this.formObserver = new MutationObserver(() => {
      if (!this.querySelector('textarea[name="textarea"]')) return;
      this.selectDefaultProductCategory();
      if (this.dialog?.open) this.syncQuoteSummary();
    });
    if (this.formHost) this.formObserver.observe(this.formHost, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleDocumentClick);
    this.dialog?.removeEventListener('click', this.handleDialogClick);
    this.dialog?.removeEventListener('close', this.handleDialogClose);
    this.removeEventListener('click', this.handleFormInteraction, true);
    this.removeEventListener('submit', this.handleFormInteraction, true);
    this.formObserver?.disconnect();
  }

  handleDocumentClick(event) {
    const trigger = event.target.closest('[data-hbb-quote-open]');
    if (!trigger || trigger.dataset.hbbQuoteOpen !== this.dataset.productId) return;

    event.preventDefault();
    this.open();
  }

  handleDialogClick(event) {
    if (event.target === this.dialog || event.target.closest('[data-hbb-quote-close]')) {
      this.dialog.close();
    }
  }

  handleDialogClose() {
    document.documentElement.classList.remove('hbb-quote-modal-open');
  }

  handleFormInteraction(event) {
    if (event.type === 'submit' || event.target.closest('button[type="submit"], input[type="submit"]')) {
      this.syncQuoteSummary();
    }
  }

  open() {
    if (!this.dialog || this.dialog.open) return;

    this.selectDefaultProductCategory();
    this.syncQuoteSummary();
    this.dialog.showModal();
    document.documentElement.classList.add('hbb-quote-modal-open');

    requestAnimationFrame(() => {
      this.dialog.querySelector('input:not([type="hidden"]), select, textarea, button')?.focus({ preventScroll: true });
    });
  }

  selectDefaultProductCategory() {
    const categories = this.querySelectorAll(
      '.globo-form-control[data-element-id="checkbox-1"] input[type="checkbox"]'
    );
    const category = categories[categories.length - 1];

    if (category && !category.checked) {
      category.checked = true;
      category.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  syncQuoteSummary() {
    const textarea = this.querySelector(
      '.globo-form-control[data-element-id="textarea"] textarea, textarea[name="textarea"]'
    );
    if (!textarea) return;

    const currentValue = textarea.value || '';
    const existingDescription = currentValue.includes(HBB_QUOTE_SUMMARY_SEPARATOR)
      ? currentValue.split(HBB_QUOTE_SUMMARY_SEPARATOR).slice(1).join(HBB_QUOTE_SUMMARY_SEPARATOR)
      : currentValue;
    const quantity = Math.max(1, Number.parseInt(this.quantity?.value || '1', 10) || 1);
    const marking = this.marking?.value || 'Vet inte – hjälp mig välja';
    const selectedVariant = this.getSelectedVariant();
    const variantLine = selectedVariant ? `\nVariant: ${selectedVariant}` : '';

    textarea.value = `Produkt: ${this.dataset.productTitle}${variantLine}\nAntal: ${quantity}\nMärkning: ${marking}\nProduktlänk: ${this.dataset.productUrl}${HBB_QUOTE_SUMMARY_SEPARATOR}${existingDescription}`;
    textarea.dispatchEvent(new Event('input', { bubbles: true }));
    textarea.dispatchEvent(new Event('change', { bubbles: true }));
  }

  getSelectedVariant() {
    const productDetails = this.closest('.product-details');
    if (!productDetails) return '';

    const selectedValues = Array.from(
      productDetails.querySelectorAll('variant-picker input[type="radio"]:checked, variant-picker select')
    )
      .map((input) => input.value)
      .filter(Boolean);

    return selectedValues.join(' / ');
  }
}

if (!customElements.get('hbb-product-quote-modal')) {
  customElements.define('hbb-product-quote-modal', HbbProductQuoteModal);
}
